import SchoolIcon from "@mui/icons-material/School";
import { GraduationServicePath, THESIS_DEFENSE } from "utils/constants";
import permissions from "app/permissions";
import ListThesisDefense from "./List";
import ShowThesisDefense from "./Show";

export const resources = {
  isMenu: true,
  icon: <SchoolIcon />,
  name: GraduationServicePath + THESIS_DEFENSE,
  title: "Защита на дипломна работа",
  list: <ListThesisDefense />,
  show: <ShowThesisDefense />,
  permission: permissions.canPreviewThesisDefenseRequests,
};
